<template>
    <div >
    <el-table class="pop_content_l"
            :data="tableData"
              :show-header=false
            style="width: 100%"
            @row-click="selectrow">

        <el-table-column
                prop="filename"
                label="名称"
                width="280px">
        </el-table-column>
        <el-table-column
                v-if="false"
                prop="fid"
                width="0"
                label="ID">
        </el-table-column>
    </el-table>
    <!--        分页器-->
    <div class="block">

            <el-pagination
                    @current-change="handleCurrentChange"
                    small
                    layout="prev, pager, next"
                    :total="this.total">
            </el-pagination>

    </div>
    </div>
</template>

<script>
    export default {
        props: {
            flowlist: Object,

        },
        watch: {
            flowlist:{
                handler(n,o) {
                    this.tableData=n.data.list;
                    this.total=n.total;
                },
                deep:true,
            },
        },
        data() {
            return {
                tableData: [],
                total:0,
            }
        },
        methods: {
            selectrow(row){
                this.$emit('flowselect',row.fid)
            },
            handleCurrentChange(val) {
                this.$emit('pagechange',val)
            }
        }
    }
</script>

<style scoped>
    .pop_content_l {


        color: #107750;

        overflow: hidden;
    }
    </style>
